module.exports = __webpack_public_path__ + "img/icon-sb-outside-drop-off-icon-160x120-v1.70be1a4.svg";